type SubdomainResult = {
  hostname: string;
  subdomain: string;
  port: string | undefined;
  domainUrl: string;
};
const getSubdomain = (req: any): SubdomainResult => {
  let hostname;
  let port;
  let parts;
  let subdomain;
  let domainUrl;

  if (!__CLIENT__) {
    const { hostname: serverHostname, headers } = req;
    hostname = serverHostname;
    port = headers?.["host"]?.split(":")[1];
    parts = hostname.split(".");
    [subdomain] = parts;
    domainUrl = __DEV__ ? `http://${hostname}:${port}` : `https://${hostname}`;
  } else {
    const { hostname: clientHostname, port: clientPort } = window.location;
    hostname = clientHostname;
    port = clientPort;
    parts = hostname.split(".");
    [subdomain] = parts;
    domainUrl = __DEV__ ? `http://${hostname}:${port}` : `https://${hostname}`;
  }
  return { hostname, subdomain, port, domainUrl };
};

export default getSubdomain;
